export enum CHAT_MODE {
    knowledge = 'knowledge',
    logistics = 'logistics',
}
